package one.healthium.onboarding.domain.models


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class HighlightItem(
    @SerialName("text") val text: String,
    @SerialName("emoji") val emoji: GenderText,
)